module.exports = __webpack_public_path__ + "static/img/3.6b65d03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/nav-1/3.jpg
// module id = HwTg
// module chunks = 0